// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n@media only screen and (max-width: 600px) {\n.demo_container[data-v-f8e6c784] {\n\t\tpadding-bottom: calc(49%) !important;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
